import React from "react";

const YoutubeIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4228_102296)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.6469 4.1551C15.5551 3.81595 15.3761 3.50675 15.1276 3.2583C14.8792 3.00984 14.57 2.83081 14.2309 2.73902C12.9892 2.40039 7.99201 2.40039 7.99201 2.40039C7.99201 2.40039 2.99456 2.41064 1.75291 2.74927C1.41375 2.84107 1.10456 3.02011 0.856115 3.26857C0.607674 3.51704 0.428657 3.82625 0.336892 4.16542C-0.0386761 6.37158 -0.184366 9.73325 0.347205 11.8512C0.43898 12.1903 0.618001 12.4995 0.866441 12.748C1.11488 12.9964 1.42407 13.1755 1.76323 13.2672C3.00487 13.6059 8.0022 13.6059 8.0022 13.6059C8.0022 13.6059 12.9995 13.6059 14.241 13.2672C14.5802 13.1755 14.8894 12.9964 15.1379 12.748C15.3863 12.4995 15.5654 12.1903 15.6571 11.8512C16.0533 9.64188 16.1753 6.28232 15.6469 4.15517V4.1551Z",
  fill: "#FF0000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.40137 5.60156V10.4039L10.547 8.00273L6.40137 5.60156Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4228_102296"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 11.2054,
  fill: "white",
  transform: "translate(0 2.40039)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(YoutubeIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;